import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withDataProvider } from 'react-admin';
import PropTypes from 'prop-types';
import { Button } from 'ra-ui-materialui';
import { CircularProgress } from '@material-ui/core';
import jwt from 'jsonwebtoken';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@material-ui/icons';
import { push as reduxPush } from 'react-router-redux';
import {
  EditUserButton,
  LockUnlockUserButton,
  CloseAccountButton,
  SendResetPasswordEmailButton,
  ApproveAccountButton,
  AllowInvestmentPostClosingButton,
} from './actions';
import '../styles.css';

class ShowActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
    };
  }

  componentDidMount() {
    window.onclick = (event) => {
      const isUserActionButton = event.target.matches('.userActionButton');
      const isDropdownButton = event.target.closest('#userActionDropdownButton');
      if (!isUserActionButton && !isDropdownButton) {
        const element = document.getElementById('dropdownItems');
        if (element) {
          element.style.display = 'none';
        }
      }
    };
  }

  setSubmitting = isSubmitting => this.setState({ isSubmitting });

  render() {
    const { data, isLoading } = this.props;
    const {
      isSubmitting,
    } = this.state;

    const token = localStorage.getItem('authToken');
    const { user } = jwt.decode(token);
    const isOwnUser = user.id === data.id;
    return (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <Button
          variant="outlined"
          color="secondary"
          id="userActionDropdownButton"
          disabled={isSubmitting || isLoading || _.isEmpty(data)}
          label="User Actions"
          className="dropdownButton"
          onClick={() => {
            const element = document.getElementById('dropdownItems');
            const { display } = element.style;
            element.style.display = display === 'none' ? 'block' : 'none';
          }}
        >
          { isSubmitting ? <CircularProgress style={{ width: '1em', height: '1em' }} /> : <KeyboardArrowDownIcon /> }
        </Button>
        <div
          id="dropdownItems"
          style={{
            display: 'none',
            position: 'absolute',
            overflow: 'auto',
            zIndex: 1,
            width: 300,
            marginLeft: -150,
            borderRadius: 4,
          }}
        >
          <EditUserButton {...this.props} />
          {!isOwnUser && data.status !== 'review' && <LockUnlockUserButton {...this.props} setSubmitting={this.setSubmitting} /> }
          {!isOwnUser && <CloseAccountButton {...this.props} setSubmitting={this.setSubmitting} /> }
          {!isOwnUser && <SendResetPasswordEmailButton {...this.props} setSubmitting={this.setSubmitting} />}
          {!isOwnUser && !data.approvedAt && <ApproveAccountButton {...this.props} setSubmitting={this.setSubmitting} />}
          <AllowInvestmentPostClosingButton {...this.props} setSubmitting={this.setSubmitting} />
        </div>
      </div>
    );
  }
}

ShowActions.propTypes = {
  data: PropTypes.shape({}),
};

ShowActions.defaultProps = {
  data: {},
};

const mapStateToProps = (state, ownProps) => ({ isRouterLoading: state.admin.loading, resourceData: state.admin.resources[ownProps.resource].data });

const mapDispatchToProps = { push: reduxPush };

export default connect(mapStateToProps, mapDispatchToProps)(withDataProvider(ShowActions));



// WEBPACK FOOTER //
// ./src/components/User/actions/ShowActions.jsx